/* eslint-disable camelcase */
import {
	getAnnualIntervalPrice,
	getThreeMonthIntervalPrice,
} from '@common/utils/membership';
import { formatPrice } from '@common/utils/price';
import {
	SupabasePriceRecord,
	SupabasePriceRecordWithProducts,
} from '@interfaces';

interface MembershipPriceProps {
	className?: string;
	prices?: SupabasePriceRecord[] | SupabasePriceRecordWithProducts[];
	includeInterval?: boolean;
	months?: number;
	isAnnual?: boolean;
}

export const MembershipPrice = ({
	className,
	prices,
	includeInterval = true,
	isAnnual = false,
	months = 1,
}: MembershipPriceProps) => {
	const intervalPrice = isAnnual
		? getAnnualIntervalPrice(prices)
		: getThreeMonthIntervalPrice(prices);

	if (
		!intervalPrice ||
		!intervalPrice.unit_amount ||
		!intervalPrice.interval_count
	) {
		return null;
	}

	// Initialize price per month
	let pricePerMonth = 0;

	// Calculate price per month based on interval
	switch (intervalPrice.interval) {
		case 'year':
			pricePerMonth =
				intervalPrice.unit_amount / intervalPrice.interval_count / 12;
			break;
		default:
			// Default to monthly
			pricePerMonth = intervalPrice.unit_amount / intervalPrice.interval_count;
			break;
	}

	// Format price with two decimal places by default
	let formattedPrice = formatPrice({ cents: pricePerMonth * months });

	// If the prices ends with two zeros, remove them
	if (formattedPrice.endsWith('.00')) {
		formattedPrice = formattedPrice.slice(0, -3);
	}

	return (
		<span className={className}>
			{includeInterval ? `${formattedPrice} / month` : formattedPrice}
		</span>
	);
};
